module.exports = __webpack_public_path__ + "static/media/Sharrow.bf4bd94e.svg";